export default {
  data() {
    return {
      id: null,
      emp_id: null,
      name: null,
      last_name: null,
      phone: null,
      role: 'EMP',
      reporting_to: null,
      manage_by: null,
      date_of_joining: null,
      is_system_user: false,
      pictureFile: null,
      picturePreview: null,
      pictureBase64: null,
      userOptions: [],
      btnLoader: false,
      shift_id: null,
      working_mode: 'office',
      workingModeOptions: [
        { label: 'Work from office', value: 'office' },
        { label: 'Work from home', value: 'remote' },
        { label: 'Hybrid', value: 'hybrid' },
      ],
      roleOptions: [
        { code: 'SA', name: 'Super Admin' },
        { code: 'MN', name: 'Manager' },
        { code: 'HR', name: 'Human Resources' },
        { code: 'EMP', name: 'Employee' },
      ],
    }
  },
  computed: {
    avatarInitials() {
      const first = this.name ? this.name.charAt(0).toUpperCase() : ''
      const last = this.last_name ? this.last_name.charAt(0).toUpperCase() : ''
      return (first + last) || 'E'
    },
    shiftOptions() {
      return this.$store.state.app.shiftList.map(s => ({
        value: s.id,
        label: s.name,
      }))
    },
  },
  mounted() {
    this.loadUsers()
    this.loadShifts()
  },
  methods: {
    /** Load active shifts and cache in Vuex store */
    async loadShifts() {
        const response = await this.getHTTPPostResponse(
          'admin/master/shift/list',
          { is_active: true, per_page: 500 },
          false,
        )
        if (response && response.data && response.data.shifts) {
          this.$store.commit('app/UPDATE_SHIFT_LIST', response.data.shifts)
        }
    },

    /** Load active users for dropdowns */
    async loadUsers() {
      const response = await this.getHTTPPostResponse(
        'admin/master/user',
        { is_active: 1, sort_field: 'name', sort_order: 'asc' },
        false,
      )
      if (response && response.data) {
        this.userOptions = response.data.users.map(u => ({
          value: u.id,
          label: `${u.name} ${u.last_name}`,
        }))
      }
    },

    /** Populate form with existing employee data and open sidebar */
    openForEdit(data) {
      this.id = data.id
      this.emp_id = data.emp_id || null
      this.name = data.name
      this.last_name = data.last_name
      this.phone = data.phone
      this.role = data.role
      this.date_of_joining = data.date_of_joining || null
      this.is_system_user = !!data.is_system_user
      this.picturePreview = data.picture || null

      // delay so userOptions are ready before v-select resolves value
      this.$nextTick(() => {
        this.reporting_to = data.reporting_to
        this.manage_by = data.manage_by
        this.shift_id = data.shift_id || null
        this.working_mode = data.working_mode || 'office'
        this.$root.$emit('bv::toggle::collapse', 'addSystemEmployee')
      })
    },

    /** Handle profile picture file selection */
    onPictureChange(event) {
      const file = event.target.files[0]
      if (!file) return
      this.pictureFile = file
      const reader = new FileReader()
      reader.onload = e => {
        this.picturePreview = e.target.result
        this.pictureBase64 = e.target.result
      }
      reader.readAsDataURL(file)
    },

    /** Reset form on sidebar close */
    sidebarToggle() {
      this.clearData()
    },

    /** Validate then submit */
    validationForm() {
      this.$refs.sysEmpObserver.validate().then(success => {
        if (success) this.saveEmployee()
      })
    },

    /** Create or update employee */
    async saveEmployee() {
      this.btnLoader = true

      const input = {
        emp_id: this.emp_id,
        name: this.name,
        last_name: this.last_name,
        phone: this.phone,
        role: this.role,
        reporting_to: this.reporting_to,
        manage_by: this.manage_by,
        date_of_joining: this.date_of_joining,
        is_system_user: this.is_system_user ? 1 : 0,
        shift_id: this.shift_id || null,
        working_mode: this.working_mode || 'office',
      }

      if (this.pictureBase64) {
        input.picture = this.pictureBase64
      }

      let response = null

      if (this.id) {
        // Edit — PUT update
        response = await this.getHTTPPutResponse(
          `admin/master/system-employee/update/${this.id}`,
          input,
          true,
        )
      } else {
        // Create — POST createApi
        response = await this.getHTTPPostResponse(
          'admin/master/system-employee/create',
          input,
          true,
        )
      }

      if (response && response.status === 200) {
        this.$root.$emit('bv::toggle::collapse', 'addSystemEmployee')
        this.$emit('employeeCreated')
      }

      this.btnLoader = false
    },

    /** Clear all form fields */
    clearData() {
      this.id = null
      this.emp_id = null
      this.name = null
      this.last_name = null
      this.phone = null
      this.role = 'EMP'
      this.reporting_to = null
      this.manage_by = null
      this.date_of_joining = null
      this.is_system_user = false
      this.shift_id = null
      this.working_mode = 'office'
      this.pictureFile = null
      this.picturePreview = null
      this.pictureBase64 = null
      if (this.$refs.sysEmpObserver) {
        this.$refs.sysEmpObserver.reset()
      }
    },
  },
}
